/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonGeneric.vue?vue&type=template&id=f5334472"
import script from "./ButtonGeneric.ts?vue&type=script&lang=ts&external"
export * from "./ButtonGeneric.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports